module.exports = __webpack_public_path__ + "static/img/temeljnica.a04477a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/temeljnica.png
// module id = UZeP
// module chunks = 0